import React, { useState } from "react";

export const Tabs = ({
  children,
  defaultValue,
  value: controlledValue,
  onValueChange,
  className = "",
}) => {
  const [internalTab, setInternalTab] = useState(defaultValue);
  const isControlled = controlledValue !== undefined;
  const activeTab = isControlled ? controlledValue : internalTab;

  const handleTabChange = (val) => {
    if (!isControlled) {
      setInternalTab(val);
    }
    if (onValueChange) {
      onValueChange(val);
    }
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        activeTab,
        onTabChange: handleTabChange,
      });
    }
    return child;
  });

  return <div className={className}>{childrenWithProps}</div>;
};

export const TabsList = ({
  children,
  activeTab,
  onTabChange,
  className = "",
}) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        isActive: activeTab === child.props.value,
        onSelect: onTabChange,
      });
    }
    return child;
  });

  return (
    <div
      className={`flex border-b border-gray-200 dark:border-gray-700 ${className}`}
    >
      {childrenWithProps}
    </div>
  );
};

export const TabsTrigger = ({
  children,
  value,
  isActive,
  onSelect,
  className = "",
}) => {
  const baseStyles = "px-4 py-2 font-medium text-sm cursor-pointer";
  const activeStyles = isActive
    ? "text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400"
    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300";

  return (
    <div
      className={`${baseStyles} ${activeStyles} ${className}`}
      onClick={() => onSelect(value)}
    >
      {children}
    </div>
  );
};

export const TabsContent = ({ children, value, activeTab, className = "" }) => {
  if (value !== activeTab) return null;

  return <div className={`py-4 ${className}`}>{children}</div>;
};
